import { Network } from "@/model";
import { sliceActions } from "./network.slice";
import { AppThunk } from "..";
import { networkApi } from "@/apis";

export const getNetworks = (): AppThunk => async (dispatch) => {
  try {
    dispatch(sliceActions.loadingPreGetNetworks());
    const data: Network[] = await networkApi.getNetworks({
      status: false,
    });

    if (data?.[0]) {
      dispatch(sliceActions.preGetNetworksSuccess(data));
    }
  } catch (err) {
    dispatch(sliceActions.preLoadingGetFail());
  }
};

export const self = sliceActions;
